import { CheckboxGroup, Flex, Hint, ManagedCheckbox } from '@lokalise/louis';

import type { Value } from './types';
import { optionsKeys } from './utils/generateOptions';

const prepareIncomingValue = (value: Value): string[] =>
    Object.entries(value)
        .filter(([, val]) => val)
        .map(([key]) => key);

const prepareOutgoingValue = (value: readonly string[], keys: (keyof Value)[]): Value => {
    const outgoingValue = {} as { [key in keyof Value]: boolean };

    keys.forEach((key) => {
        outgoingValue[key] = value.includes(key);
    });

    return outgoingValue;
};

export interface OptionsCheckboxesProps {
    value: Value;
    options: {
        value: keyof Value;
        label: string | JSX.Element;
        description: string | JSX.Element;
    }[];
    onChange: (value: Value) => void;
}

const OptionsCheckboxes = ({ value, options, onChange }: OptionsCheckboxesProps) =>
    options.length ? (
        <CheckboxGroup
            name="options"
            value={prepareIncomingValue(value)}
            onChange={(_, val) => onChange(prepareOutgoingValue(val, optionsKeys))}
        >
            <Flex gap={3} direction="column">
                {options.map(({ label, description, ...rest }) => (
                    <ManagedCheckbox key={rest.value} value={rest.value}>
                        {label} <Hint placement="right">{description}</Hint>
                    </ManagedCheckbox>
                ))}
            </Flex>
        </CheckboxGroup>
    ) : null;

export default OptionsCheckboxes;
